import { emailConversationsPageSchema, type EmailConversationsPage } from "@gioia365/contracts";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { apiRequest } from "../api/http";
import { tabKey, type TabContext } from "../session/tab-context";
import { conversationKeys } from "./conversation-keys";
import { CONVERSATIONS_PAGE_SIZE } from "./conversation-queries";
import type { EmailConversationsRequest } from "./conversation-search";

// La lettura della scheda «Email» di «Conversazioni» (piano dell'ingresso del 12 ottobre 2026, I5, D5; rotta e contratti in
// `packages/contracts/src/conversations.ts`): `GET /api/conversations/email` a pagine con il cursore, con periodo, «Di chi» e ricerca
// dell'indirizzo. In sola lettura: gli eventi li scrive GoHighLevel, quindi la lista si rilegge ogni minuto mentre è aperta, come i
// WhatsApp.

/** Ogni quanto la lista aperta si rilegge: gli eventi arrivano da soli. */
const EMAIL_REFRESH_MS = 60_000;

function listPath(query: EmailConversationsRequest, cursor: string | null): string {
  const params = new URLSearchParams({ period: query.period });
  if (query.from !== undefined) params.set("from", query.from);
  if (query.to !== undefined) params.set("to", query.to);
  if (query.who !== undefined) params.set("who", query.who);
  if (query.q !== undefined && query.q !== "") params.set("q", query.q);
  if (cursor !== null) params.set("cursor", cursor);
  params.set("limit", String(CONVERSATIONS_PAGE_SIZE));
  return `/api/conversations/email?${params.toString()}`;
}

/** Le pagine degli eventi delle email: la successiva dal cursore della precedente, finché il server ne dà uno. */
export function emailPagesQuery(tab: TabContext, query: EmailConversationsRequest, view: string | null) {
  return infiniteQueryOptions({
    queryKey: conversationKeys.email(tabKey(tab), view, query),
    queryFn: ({ signal, pageParam }) => apiRequest("GET", listPath(query, pageParam), { schema: emailConversationsPageSchema, tab, signal }),
    initialPageParam: null as string | null,
    getNextPageParam: (last: EmailConversationsPage) => last.nextCursor ?? undefined,
    staleTime: 30_000,
    refetchInterval: EMAIL_REFRESH_MS,
  });
}
